import { render, staticRenderFns } from "./InputData.vue?vue&type=template&id=146f1949&scoped=true&"
import script from "./InputData.vue?vue&type=script&lang=js&"
export * from "./InputData.vue?vue&type=script&lang=js&"
import style0 from "./InputData.vue?vue&type=style&index=0&id=146f1949&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f1949",
  null
  
)

export default component.exports